import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import styled from 'styled-components'

interface Props extends Pick<FontAwesomeIconProps, 'size'> {}

const IconContainer = styled.div`
  position: relative;
  animation: rotation 2s infinite linear;
`

const IconSpinner: FC<Props> = ({ size }) => (
  <IconContainer>
    <FontAwesomeIcon spin size={size} icon={faSpinner} />
  </IconContainer>
)

export default IconSpinner
